import React, { Component } from 'react';

export class VideoListItem extends Component {
	
	render() {
		return (
			<li onClick={() => this.props.onVideoSelect(this.props.video)}>
                <div className='thumbnail-container'>
                    {this.props.isYouTube ?
                        <img className='thumbnail-img' src={this.props.videoThumbnail} alt={this.props.videoTitle + ' thumbnail'} /> :
                        <img className='thumbnail-img' src={this.props.altThumbnail} alt={this.props.videoTitle + ' thumbnail'} />
                    }
                    <div className='thumbnail-overlay'><span className='glyphicon glyphicon-play-circle'></span></div>
                </div>
                <h3 className='video-list-item-title'>{this.props.videoTitle}</h3>
                <div className='video-list-item-date'>Published on {this.props.videoDate}</div>
            </li>
		);
	}
}